<template>
<div class="chapter">
<div class="inner_page">
<div style="margin-top:2em;">
<h2 class="h2v"><a id="page_xi"></a>PREFACE</h2>
<p class="noindent">A book such as this does not require an extensive and ponderous preface: rather, a short and ponderous preface will suffice. Far from being an exhaustive treatment of Plato's <em>Cratylus,</em> this book hopes to show the impossibility of exhausting the Platonic dialogue. Even after this work there is much that remains concealed in Plato's <em>Cratylus,</em> and shall perhaps forever remain concealed. My hope is that this present work will inspire new and creative research into this exquisite and tremendously complex dialogue. To all those future interpreters of Plato's challenging work, I offer you the same self-serving words that Socrates offers Cratylus at the end of the dialogue that bears his name: “You must continue to consider [these matters] courageously and thoroughly and not accept anything carelessly—for you are still young and in your prime; then, if after investigating, you find the truth, please share it with me” (44od).</p>
<p class="preface">A cold day in Boston—January, 2013<a id="page_xii"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Preface.vue?6076d097